import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthenticationResult,
  BrowserCacheLocation,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MsalEnv } from '@qaroni-core/config/apis/msal/msal.config';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftAuthService {
  private router = inject(Router);

  private msalInstance = new PublicClientApplication({
    auth: {
      clientId: MsalEnv.clientId,
      authority: MsalEnv.authority,
      redirectUri: MsalEnv.redirectUri,
      OIDCOptions: {
        responseMode: 'query',
      },
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  });

  private initialized: Promise<void> = this.msalInstance.initialize();
  private idToken: string | null = null;

  public async login(): Promise<void> {
    await this.initialized;
    await this.msalInstance.loginRedirect({ scopes: MsalEnv.scopes });
  }

  public async handleRedirect(): Promise<void> {
    await this.initialized;
    const result: AuthenticationResult =
      await this.msalInstance.handleRedirectPromise();

    if (result?.idToken) {
      this.idToken = result.idToken;
      this.router.navigate(['/auth/microsoft']);
    }
  }

  public getIdToken(): string | null {
    return this.idToken;
  }

  public async clearCache(): Promise<void> {
    await this.initialized;
    await this.msalInstance.clearCache();
  }
}
